export enum LocationCategory {
  ACQUISITION = 'Acquisition',
  DENOVO = 'De Novo',
  JOINT_VENTURE = 'Joint Venture',
}
